export default __webpack_public_path__ + "static/media/ip1X.b59d57f7.svg";